import { HttpClient } from '@adapters/HttpClient';

export interface ShipmentBlockReasonOption {
  id: string;
  name: string;
}

export class ShipmentBlockReasonsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  // Obtiene los motivos de bloqueo desde /invoices/block-reasons
  async getAll(): Promise<ShipmentBlockReasonOption[]> {
    const raw = await this.httpClient.get<any>('/invoices/block-reasons', {
      per_page: 1000,
    });
    const list = Array.isArray(raw) ? raw : raw.data || [];
    return list.map((item: any) => ({ id: String(item.id), name: item.name }));
  }
}


